import {Box, Pagehead} from '@primer/react'
import type {ReactNode} from 'react'

interface Props {
  title: ReactNode
  subtitle?: ReactNode
  actions?: ReactNode
}
export function PageHeader({title, subtitle, actions}: Props) {
  return (
    <>
      <Pagehead sx={{pb: 2, pt: 0, mb: 3}}>
        <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 2}}>
          {title}
          {actions && <Box sx={{display: 'flex', gap: 1}}>{actions}</Box>}
        </Box>
      </Pagehead>
      {subtitle && (
        <Box as="p" sx={{color: 'fg.muted', mb: 3}}>
          {subtitle}
        </Box>
      )}
    </>
  )
}

try{ PageHeader.displayName ||= 'PageHeader' } catch {}